import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class Range extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(Range, v) : SKIP;
            },
            (v) => {
                return deserialize(Range, v) || new Range();
            }
        );
    }

    constructor(lower = 0, upper = 0) {
        super();
        this._lower = lower;
        this._upper = upper;
    }

    get lower() {
        return this._lower;
    }

    set lower(value) {
        this._lower = value;
    }

    get upper() {
        return this._upper;
    }

    set upper(value) {
        this._upper = value;
    }

    get string() {
        return this.lower + " - " + this.upper;
    }

    collide(range) {
        return (this.lower <= range.lower && range.lower <= this.upper) ||
            (this.lower <= range.upper && range.upper <= this.upper);
    }

    valid(support_negative) {
        if (Number.isNaN(this.lower) || Number.isNaN(this.upper)) {
            return false;
        }

        return (support_negative || 0 <= this.lower) && this.lower <= this.upper;
    }

    empty() {
        return this.lower === 0 && this.upper === 0;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new Range());
        } else if (target instanceof Range) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(Range, {
    _lower: alias("min", Schema.primitive()),
    _upper: alias("max", Schema.primitive())
});